import 'css-chunksrc/client/scenes/notifications/notification/addedToProject/styles.scss';export default {
  "notification": "_notification_1tgcq_1",
  "header": "_header_1tgcq_8",
  "date": "_date_1tgcq_18",
  "main": "_main_1tgcq_24",
  "author": "_author_1tgcq_28",
  "avatar": "_avatar_1tgcq_38",
  "authorName": "_authorName_1tgcq_43",
  "text": "_text_1tgcq_49",
  "content": "_content_1tgcq_56",
  "mention": "_mention_1tgcq_63",
  "project": "_project_1tgcq_67"
};